export enum SuccessMessages {
  Updated = 'Updated Successfully',
  Removed = 'Removed Successfully',
}

export enum ErrorMessages {
  InvalidEmail = 'Invalid Email',
  InvalidEntry = 'Invalid Entry',
}
